import { MdArrowBackIos } from "react-icons/md";
import { useResourceViewer } from "../../../../components/customHook/ResourceViewer";
import MediaViewerModal from "../../../../components/modal/MediaViewerModal";
import { PANEL_STATUS } from "../../../../config/Constant";
import { useMenuContext } from "../../../../context/MenuContext";
import { useInfoUser } from "../../../../store/UserStore";
import { MediaStorageView } from "../MediaStorageView";

const MediaStoragePanel = ({ jumpToMessage, isMail = false }) => {
  const { setPanelStatus } = useMenuContext();
  const { languageMap } = useInfoUser();

  const resourceViewer = useResourceViewer();
  return (
    <div className="chat-right-panel h-screen bg-white border-l flex flex-col">
      {/* Header */}
      <div className="relative p-3 border-b flex justify-center items-center h-[70px]">
        <button
          size="small"
          onClick={() => setPanelStatus(PANEL_STATUS.GROUP_INFO)}
          className="absolute left-3 cursor-pointer p-2"
        >
          <MdArrowBackIos size={20} />
        </button>

        <span className="absolute left-1/2 -translate-x-1/2 font-semibold text-[18px]">
          {languageMap?.["menu.conversation.mediaStorage"] ?? "Media storage"}
        </span>
      </div>
      {/* Content */}
      <div className="flex flex-col h-screen overflow-y-scroll w-[350px]">
        <MediaStorageView
          jumpToMessage={jumpToMessage}
          resourceViewer={resourceViewer}
          isMail={isMail}
        />
      </div>
      {/* Modal viewer */}
      {resourceViewer?.visible && (
        <MediaViewerModal resourceViewer={resourceViewer} />
      )}
    </div>
  );
};

export { MediaStoragePanel };
